import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import DeepChatBot from "../DeepChatBot/DeepChatBot";
import styles from "./ChatBotWrapper.module.css";
import logo from "../../assets/images/Logo/firstland-full-white-no_bg.png";

function ChatBotWrapper() {
  const location = useLocation();
  const [isChatOpen, setIsChatOpen] = useState(false);

  // Define routes where the chatbot should appear
  const chatbotRoutes = [
    "/",
    "/Realtors-and-Brokers",
    "/Landlord",
    "/agency-onbaord",
    "/realtor-onbaord",
    "/realtor/add-property",
    "/Agencies",
  ];

  // Check if the current route matches any in the chatbotRoutes array
  const shouldDisplayChatbot = chatbotRoutes.includes(location.pathname);

  const toggleChat = () => {
    setIsChatOpen((prev) => !prev);
  };

  return (
    shouldDisplayChatbot && (
      <>
        {/* Chat Icon */}
        <div className={styles.chatIcon} onClick={toggleChat}>
          <div className={styles.chatCircle}>💬</div>
        </div>

        {/* Chat Popup */}
        {isChatOpen && (
          <div className={styles.chatPopup}>
            <div className={styles.chatHeader}>
              <div className={styles.chatLogo}>
                <img src={logo} alt={"FirstLand"} />
              </div>

              <button className={styles.closeButton} onClick={toggleChat}>
                ✖
              </button>
            </div>
            <DeepChatBot />
          </div>
        )}
      </>
    )
  );
}

export default ChatBotWrapper;
